// De quien es el torneo, y de quien es el partido.
//
// Son las dos preguntas que deciden que puede hacer el club, y estaban contestadas a
// mano en cada pantalla -- o peor, no contestadas: la unica guardia para capturar
// juegos era el ROL del usuario, asi que un coach de un club invitado podia poner
// marcadores en un torneo que no era suyo.
//
// La regla la impone la base (trigger _juegos_guard). Esto es para que la UI no
// ofrezca botones que la base va a rechazar.
//
// REGLA UNICA (2026-09-05): un torneo SIEMPRE tiene organizadora. En el torneo interno
// es el propio club (el organizador de afuera no esta en MYKLUBB, asi que el club lo
// crea y lo lleva); en MYKLUBB Torneos es la organizadora de la red. La columna es NOT
// NULL desde 20260905_torneos_organizadora_obligatoria, asi que
//
//     externo  <=>  organizadora <> mi org
//     captura  <=>  organizadora  = mi org
//
// y si a la pantalla le llega un torneo SIN ese campo no es dato viejo: es que la
// consulta no lo pidio. Sin el dato no se afirma nada que abra un boton. Antes existia
// la excepcion "sin organizadora = interno", que era una de CUATRO respuestas distintas
// a la misma pregunta repartidas entre UI, lista, RPC y modal.

// El dato llega con dos nombres segun la consulta: la columna cruda (embeds) o el
// objeto ya resuelto (getAllTorneosWithInscripciones).
const organizadoraDe = (torneo) =>
  torneo?.organizadora?.id || torneo?.org_organizadora_id || null

// El torneo es de OTRA organizacion. Solo se afirma con evidencia.
export const esTorneoExterno = (torneo, orgId) => {
  if (!orgId) return false
  const organizadora = organizadoraDe(torneo)
  return Boolean(organizadora) && organizadora !== orgId
}

// La pregunta que de verdad hacen las pantallas: ¿el club captura aqui? Solo si la
// organizadora se conoce y es la propia org. (Sin orgId la igualdad ya falla sola: una
// guarda aparte era codigo muerto, lo probo un mutante que sobrevivio.)
export const clubCapturaEsteTorneo = (torneo, orgId) => {
  const organizadora = organizadoraDe(torneo)
  return Boolean(organizadora) && organizadora === orgId
}

// De que mundo es una inscripcion que esta por hacerse: true = interno (el club
// inscribe y queda de una vez), false = de la red (solicitud a la organizadora), null =
// no se puede saber todavia y hay que preguntar a la base.
//
// Un `esLocal` explicito (lo pone quien abre el modal) manda. Si no, decide la
// organizadora del torneo con la misma regla que todo lo demas. Antes el modal saltaba
// directo a la RPC es_torneo_propio, que contesta segun el club del USUARIO: viendo como
// otra organizacion (platform admin) decia "no es tuyo" y abria el flujo de la red en un
// torneo interno -- con "categoria convocada", "pidele a la organizadora" y "Enviar
// solicitud". El dueno lo vio el 2026-09-05.
export const esLocalParaInscribir = (torneo, orgId) => {
  if (typeof torneo?.esLocal === 'boolean') return torneo.esLocal
  const organizadora = organizadoraDe(torneo)
  if (!organizadora || !orgId) return null
  return organizadora === orgId
}

// El partido viene del rol oficial de la organizadora: el club lo ve, le toma
// asistencia, imprime su tarjeton -- pero no lo edita ni lo borra. Su verdad vive del
// otro lado.
export const esJuegoDelRolOficial = (juego) => Boolean(juego?.torneo_juego_id)

// Se puede editar/borrar este partido desde el club.
export const puedeEditarJuego = (juego, orgId) => {
  // Sin juego no hay permiso que dar: mientras carga, la pantalla no debe ofrecer
  // editar ni borrar. Antes decia que si, y solo el `juego &&` de cada llamador lo tapaba.
  if (!juego) return false
  if (esJuegoDelRolOficial(juego)) return false
  // Todo juego tiene torneo (juegos.torneo_id es NOT NULL). Si no viene, la consulta
  // no lo pidio, y clubCapturaEsteTorneo contesta que no.
  return clubCapturaEsteTorneo(juego.torneo || juego.torneos || null, orgId)
}
